import * as S from './buttons.styles.js'
import { ChatIcon } from '../../../icons'
import { intercomService } from '../../../services/Analytics/platforms/intercom'
import { EVENT_NAMES, analytics } from '../../../services/Analytics/Analytics'
import { useLocation } from 'react-router'

export default function ChatSupportButton({
  onChatOpen = () => {},
  color,
  source = 'Top Bar',
}: {
  onChatOpen?: () => void
  color?: string
  source?: string
}) {
  const location = useLocation()

  function handleClick() {
    intercomService.show()
    analytics.track(EVENT_NAMES.TALK_TO_US_TAPPED, {
      Source: source,
      URL: location.pathname,
    })
    onChatOpen()
  }

  return (
    <S.Clickable onClick={handleClick} $color={color}>
      <ChatIcon color={color} />
    </S.Clickable>
  )
}
